import { useTranslation } from 'react-i18next';
import Placeholder from '../../components/Placeholder';

/** 廣告申請（tab 4；接 CoEldery85 廣告平台）—— 未做，誠實佔位（M8） */
export default function AdvertisementPage() {
  const { t } = useTranslation();
  return <Placeholder title={t('tab.ads')}>{t('page_todo')}</Placeholder>;
}
